import axios from 'axios';

const BASE_API = process.env.REACT_APP_API_URL || 'http://localhost:3000/api/v1';

/**
 * Get shifts for a specific restaurant and date
 * @param {number} restaurantId - The restaurant ID
 * @param {string} date - The date in YYYY-MM-DD format
 * @returns {Promise<{ shifts: Array }>}
 */
export const getShiftsForDate = async (restaurantId, date) => {
  try {
    const response = await axios.get(
      `${BASE_API}/public/shifts/restaurant/${restaurantId}/date/${date}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching shifts:', error);
    return { shifts: [] };
  }
};
